export default "__VITE_ASSET__CM6o1d3Z__"